/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainer_repliesConnection = {
    readonly viewNewEdges: ReadonlyArray<{
        readonly cursor: unknown;
        readonly node: {
            readonly id: string;
            readonly replyCount: number;
            readonly " $fragmentRefs": FragmentRefs<"ReplyListCommentContainer_comment">;
        };
    }> | null;
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly id: string;
            readonly replyCount: number;
            readonly " $fragmentRefs": FragmentRefs<"ReplyListCommentContainer_comment">;
        };
    }>;
    readonly " $refType": "ReplyListContainer_repliesConnection";
};
export type ReplyListContainer_repliesConnection$data = ReplyListContainer_repliesConnection;
export type ReplyListContainer_repliesConnection$key = {
    readonly " $data"?: ReplyListContainer_repliesConnection$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer_repliesConnection">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "replyCount",
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ReplyListCommentContainer_comment"
            }
        ],
        "storageKey": null
    } as any);
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "ReplyListContainer_repliesConnection",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    (v0 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "CommentEdge",
                        "kind": "LinkedField",
                        "name": "viewNewEdges",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "cursor",
                                "storageKey": null
                            },
                            (v0 /*: any*/)
                        ],
                        "storageKey": null
                    }
                ]
            }
        ],
        "type": "CommentsConnection",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '3d72901812a566db275491858abaa06b';
export default node;
